/** Normalize permission group ids from API / session user shapes. */

export function normalizePermissionGroupIds(user) {
  if (!user || typeof user !== "object") return [];

  if (Array.isArray(user.permission_group_ids)) {
    return user.permission_group_ids
      .map((id) => Number(id))
      .filter((id) => id > 0);
  }

  if (Array.isArray(user.permission_groups)) {
    return user.permission_groups
      .map((g) => Number(g?.id))
      .filter((id) => id > 0);
  }

  const single = user.permission_group_id;
  if (single != null && single !== "" && Number(single) !== 0) {
    return [Number(single)];
  }

  return [];
}

export function userIsInPermissionGroup(user, groupId) {
  if (groupId == null || groupId === "") return false;
  const target = Number(groupId);
  return normalizePermissionGroupIds(user).includes(target);
}

export function applyPermissionGroupsToUser(user, payload) {
  if (!user || typeof user !== "object" || !payload) return user;

  const groups = Array.isArray(payload.permission_groups)
    ? payload.permission_groups
    : [];
  const ids =
    Array.isArray(payload.permission_group_ids) && payload.permission_group_ids.length
      ? payload.permission_group_ids.map((id) => Number(id)).filter((id) => id > 0)
      : groups.map((g) => Number(g.id)).filter((id) => id > 0);

  const names = groups.length
    ? groups.map((g) => g.name).filter(Boolean)
    : payload.permission_group_name
      ? String(payload.permission_group_name).split(",").map((s) => s.trim()).filter(Boolean)
      : [];

  return {
    ...user,
    permission_group_ids: ids,
    permission_groups: groups.length
      ? groups
      : ids.map((id, i) => ({ id, name: names[i] || "" })),
    permission_group_id: ids[0] ?? null,
    permission_group_name: names.length ? names.join(", ") : null,
  };
}
